import * as React from 'react';
import './SuccessMessage.css';


export interface ISuccessMessageProps {
  message: string;
}

class SuccessMessage extends React.Component<ISuccessMessageProps, object> {

  public constructor(props: ISuccessMessageProps) {
    super(props);
  }



  public render() {

    if (this.props.message === undefined || this.props.message === '') {
      return null;
    }

    return (
      <div className="successMessage" >
        <span>{this.props.message}</span>
      </div>

    );
  }
}

export default SuccessMessage;


// WEBPACK FOOTER //
// ./src/components/SuccessMessage.tsx